import {
  AddNotification,
  AddToastNotification,
  ShowToast,
  RemoveToastNotification,
  ReadAllNotifications,
  RemoveAllNotifications,
  RemoveAllToasts,
  RemoveToastById,
} from '~/constants/mutations';
import { GetNotifications, GetToastNotifications } from '~/constants/getters';

const defaultState = () => {
  return {
    toasts: [],
    notifications: [],
  };
};

const state = defaultState;

const mutations = {
  [AddNotification](state, notification) {
    const itemIndex = (state.notifications || []).findIndex((n) => n.id === notification.id);

    if (itemIndex === -1) {
      state.notifications = [notification, ...state.notifications];
    } else {
      state.notifications[itemIndex] = notification;
    }
  },

  [AddToastNotification](state, toast) {
    const itemIndex = (state.toasts || []).findIndex(
      (t) => t.notification.externalId === toast.notification.externalId,
    );

    if (itemIndex === -1) {
      state.toasts = [toast, ...state.toasts];
    }
  },

  [ReadAllNotifications](state) {
    const readAt = new Date().toISOString();
    state.notifications = (state.notifications || []).map((n) => ({ ...n, readAt }));
    console.log(state.notifications);
  },
  [RemoveAllNotifications](state) {
    state.notifications = [];
  },
  [RemoveAllToasts](state) {
    state.toasts = [];
  },
  [RemoveToastById](state, id) {
    state.toasts = state.toasts.filter((t) => t.notification.externalId !== id);
  },
};

const getters = {
  [GetNotifications]: (state) => state.notifications,
  [GetToastNotifications]: (state) => state.toasts,
};

const actions = {
  [AddToastNotification]: ({ commit }, toast) => {
    commit(AddToastNotification, toast);

    /**
     * Allowing the enter animation to take place
     * on the bb toast message component.
     */
    setTimeout(() => {
      commit(ShowToast, toast.id);
    }, 500);

    /**
     * Allowing the exit animation to take place
     * on the bb toast message component.
     */
    if (toast.duration >= 0) {
      setTimeout(() => {
        commit(RemoveToastNotification, toast.id);
      }, parseInt(toast.duration) + 500);
    }
  },

  [AddNotification]: ({ commit }, notification) => {
    commit(AddNotification, notification);
  },
  [RemoveAllNotifications]: ({ commit }) => {
    commit(RemoveAllNotifications);
  },
  [ReadAllNotifications]: ({ commit }) => {
    commit(ReadAllNotifications);
  },
};

export default {
  namespaced: true, // Important for namespacing module
  state,
  mutations,
  actions,
  getters,
};
